
export default function Catalog() {
  return (
    <section id="catalog" className="py-24 bg-gradient-to-br from-blue-950 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-700 rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Descargue Nuestro Catálogo Completo
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Acceda al catálogo actualizado con especificaciones técnicas detalladas de todas nuestras soluciones certificadas CE.
            </p>
            <a 
              href="#" 
              className="inline-block bg-white text-blue-900 px-10 py-4 rounded-lg text-base font-bold hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
            >
              <i className="ri-download-2-line mr-2"></i>
              Descargar Catálogo
            </a>
            
            <div className="mt-12 grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl font-bold text-white mb-1">10+</div>
                <div className="text-sm text-blue-200">Modelos</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">CE</div>
                <div className="text-sm text-blue-200">Certificado</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">ISO</div>
                <div className="text-sm text-blue-200">Calidad</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-[3/4] max-w-md mx-auto">
              <img 
                src="https://public.readdy.ai/ai/img_res/6c897162ec2a4eabeaa3f776bfff6122.jpg"
                alt="Catálogo BIGBATTERY EUROPE"
                className="w-full h-full object-cover object-center rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
